import { Table as TableIcon } from '@ondit/ui/icons'
import { noop } from '@ondit/utils/helpers'
import { type BreadcrumbItem, ResourceChromeFallback } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

const breadcrumbs = (rootLabel: string): BreadcrumbItem[] => [
  { label: rootLabel, icon: TableIcon, onClick: noop },
  { label: '…', terminal: true },
]

export default function TableLoading() {
  const t = useT()
  // The table editor's header has no static actions at load (import/run controls
  // are data-gated) and its options bar is sort + filter with no search. The grid
  // body fills in once the editor mounts, so no table chrome is rendered here.
  return (
    <ResourceChromeFallback
      icon={TableIcon}
      breadcrumbs={breadcrumbs(t('Tables'))}
      hasSort
      hasFilter
    />
  )
}
